@if ((this.client$ | async); as client) {
  <div [formGroup]="formGroup">
    <p>
      Bij de klantinstellingen van {{ client.name }} maak je een koppeling met een SnelStart
      administratie.<br/>
      Hieronder kun je er voor kiezen de gegevens uit de administratie te gebruiken bij de belastingaangifte.<br/>
      Maak je na het inlezen wijzigingen in de administratie, dan worden deze NIET automatisch opnieuw ingelezen in de
      aangifte. <br/>Je kunt er wel alsnog zelf voor kiezen de nieuwe gegevens in te lezen. Zie 'Toelichting'.<br/>
    </p>
    <div class="row align-items-center">
      <div class="col-xl-3 col-lg-4 col-md-6">
        <snelstart-ui-select-form-control formControlName="administrationId"
                                          id="administrationId"
                                          label="Selecteer administratie"
                                          [options]="(this.administrationOptions$ | async) ?? []"
                                          class="me-1 custom-input-250">
        </snelstart-ui-select-form-control>
      </div>
      @if ((this.selectedAdministration$ | async) && (this.identityProviderStatus$ | async) && !(this.identityProviderStatus$ | async)?.authenticated) {
        <div class="col-xl-3 col-lg-4 col-md-6 pt-1">
          <span>U bent niet aangemeld bij {{ (this.identityProviderStatus$ | async)?.name }}</span>
        </div>
      }
    </div>
    @if ((this.selectedAdministration$ | async)) {
      <div class="row">
        @if (!(this.selectedAdministration$ | async)?.providerId) {
          <div class="col-xl-3 col-lg-4 col-md-6">
            <snelstart-ui-button [config]="this.importSnelStartBalanceButtonConfiguration"
                                 type="primary"
                                 iconRight="check"
                                 class="me-1 pt-1 custom-input-250">
              Administratie inlezen
            </snelstart-ui-button>
          </div>
        } @else if ((this.identityProviderStatus$ | async)?.authenticated) {
          <div class="col-xl-3 col-lg-4 col-md-6">
            <snelstart-ui-button [config]="this.importBalanceProviderBalanceButtonConfiguration"
                                 [disabled]="!(this.identityProviderStatus$ | async)?.authenticated"
                                 type="primary"
                                 iconRight="check"
                                 class="me-1 pt-1 custom-input-250">
              Administratie inlezen
            </snelstart-ui-button>
          </div>
        }
      </div>
    }
    <div class="space40"></div>
    @if (this.vpbDataService.vpbBerekening | async; as vpbBerekening) {
      @if (vpbBerekening?.jaarstukken?.resultaat; as resultaat) {
        @if (resultaat.totaalBedrijfsopbrengsten !== 0 && resultaat.totaalBedrijfslasten !== 0) {
          <div>
            <snelstart-ui-alert type="warning">
              Let op! De aangifte is al ingevuld. Bij het (opnieuw) inlezen van de administratie worden de
              gegevens van de balans en/of resultatenrekening overschreven.
            </snelstart-ui-alert>
          </div>
        }
      }
    }
  </div>
}
